<template>
  <div>
    <div
      v-if="estMobile"
      class="d-flex align-center justify-space-between carrousel"
    >
      <v-icon
        size="24"
        color="secondary"
        @click="ongletPrecedent"
      >
        mdi-chevron-left
      </v-icon>
      <div class="d-flex justify-center">
        <v-icon
          size="16"
          color="secondary"
        >
          {{ ongletCourant.icone }}
        </v-icon>
        <div class="titre-h3 secondary--text pl-2 align-self-center">
          {{ ongletCourant.libelle }}
        </div>
      </div>
      <v-icon
        size="24"
        color="secondary"
        @click="ongletSuivant"
      >
        mdi-chevron-right
      </v-icon>
    </div>

    <div
      v-else
      class="d-flex menu"
    >
      <div
        v-for="onglet in ongletsAffiches"
        :key="onglet.libelle"
        class="card-menu"
        :class="ongletActif === onglet.libelle ? 'active' : ''"
        @click="displayOnglet(onglet.libelle)"
      >
        <div class="d-flex justify-center">
          <v-icon
            size="16"
            color="secondary"
          >
            {{ onglet.icone }}
          </v-icon>
          <div class="titre-h3 secondary--text pl-2 align-self-center">
            {{ onglet.libelle }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const ONGLETS = [
  { libelle: 'Charges variables', icone: 'mdi-plus-circle-outline' },
  { libelle: 'Charges fixes', icone: 'mdi-plus-circle-outline' },
  { libelle: 'Co-produits', icone: 'mdi-minus-circle-outline' },
  { libelle: 'Aides et autres', icone: 'mdi-minus-circle-outline' }
]

export default {
  name: 'DetailPrixEquilibreChargesModal',

  props: {
    ongletActif: {
      type: String,
      default: 'Charges variables'
    },
    ongletsMasques: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return { ONGLETS }
  },

  computed: {
    estMobile () {
      return this.$vuetify.breakpoint.mobile
    },
    ongletsAffiches () {
      return ONGLETS.filter((onglet) => !this.ongletsMasques.includes(onglet.libelle))
    },
    indexActif () {
      const index = this.ongletsAffiches.findIndex((onglet) => onglet.libelle === this.ongletActif)
      return index >= 0 ? index : 0
    },
    ongletCourant () {
      return this.ongletsAffiches[this.indexActif]
    }
  },

  methods: {
    displayOnglet (onglet) {
      this.$emit('change', onglet)
    },
    ongletPrecedent () {
      const onglets = this.ongletsAffiches
      const index = (this.indexActif - 1 + onglets.length) % onglets.length
      this.displayOnglet(onglets[index].libelle)
    },
    ongletSuivant () {
      const onglets = this.ongletsAffiches
      const index = (this.indexActif + 1) % onglets.length
      this.displayOnglet(onglets[index].libelle)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-icon--link:focus::after {
  opacity: 0;
}

.menu {
  width: 100%;
  box-sizing: border-box;
  height: 64px;
  gap: 0;
}
.card-menu {
  background-color: var(--kaki);
  height: 64px;
  flex: 1 1 0;
  min-width: 0;
  border: 1px solid var(--kaki);
  border-radius: 16px 16px 0 0;
  padding: 24px 0 24px 0;
  cursor: pointer;
  &.active {
    background-color: white;
    border-color: white;
    position: relative;
  }
}
.carrousel {
  width: 100%;
  height: 56px;
  padding: 0 8px;
  background-color: white;
  border-radius: 16px 16px 0 0;

  .v-icon {
    cursor: pointer;
  }
}
</style>
